<template>
  <div class="third">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">校友圈动态标签配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="Reset()" class="btn-two" type="default">重置</el-button>
          <el-button
            @click="updateAlumniLabelFN()"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
          >保存</el-button>
        </div>
      </div>
      <el-form style="width:60%;float:left" :show-message="false" ref="ruleForm" label-width="86px">
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <!-- <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">学生栏目名称</span>
              </div>
            </div>-->
            <div class="one-list">
              <el-form label-width="86px">
                <el-form-item
                  v-for="(item,index) in tabdata"
                  :key="index"
                  :label="(index+1)+'、'"
                  prop="stuNumber"
                >
                  <el-input
                    style="margin-right:8px;"
                    class="item-input"
                    :maxlength="10"
                    v-model="item.content"
                    placeholder="请输入"
                  ></el-input>
                  <el-input
                    class="list-input"
                    :maxlength="50"
                    v-model="item.content_en"
                    placeholder="英文版，不填默认使用中文版内容"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <div class="phon-right">
        <img class="phon-right-img" src="@/assets/xyqmkpz.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAlumniLabel,
  updateAlumniLabel
} from "@/store/appconfig/AlumniDHTML"; //我的

export default {
  name: "formSeven",
  props: ["IDlist"],
  data() {
    return {
      //==========================
      tabdata: [] //数据数组
    };
  },
  created() {
    this.getAlumniLabelFN();
  },
  methods: {
    //重置
    Reset() {
      this.getAlumniLabelFN();
    },
    //保存
    updateAlumniLabelFN() {
      try {
        const params = this.tabdata;
        updateAlumniLabel(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.$message.success("操作成功");
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //查询
    getAlumniLabelFN() {
      try {
        getAlumniLabel().then(res => {
          const data = res.data;
          if (data.status === 1000) {
            console.log(data, '结果')
            this.tabdata = data.result;
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    }
    //==============================================
  }
};
</script>

<style lang="scss">
.phon-right{
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  height:calc(100vh - 102px);
  border-left: 1px solid #dcdee2;
  img{
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;

  }
}
</style>
